import { render, staticRenderFns } from "./data26.vue?vue&type=template&id=0d489852&scoped=true"
import script from "./data26.vue?vue&type=script&lang=js"
export * from "./data26.vue?vue&type=script&lang=js"
import style1 from "./data26.vue?vue&type=style&index=1&id=0d489852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d489852",
  null
  
)

export default component.exports